import { useQuery } from "@tanstack/react-query";
import { getCompanyKeyPersonnel } from "newui/features/Company/company-api";
import type { KeyPersonnel } from "../types/supplier-search.types";

export const useCompanyKeyPersonnel = (companyId: number | null) => {
	return useQuery<KeyPersonnel[]>({
		queryKey: ["company-key-personnel", companyId],
		queryFn: () => getCompanyKeyPersonnel(companyId!),
		enabled: !!companyId,
		staleTime: 5 * 60 * 1000,
	});
};
